import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import SHTText from "../../components/SHTText";
import SHTInput from "../../components/SHTInput";
import "../../assets/styles/page/team_information_style.css";
import SHTRadio from "../../components/SHTRadio";
import SHTButton from "../../components/SHTButton";

interface FormInputs {
  declaration: boolean;
  consent: any;
}

interface Agreement {
  id: number;
  text: string;
}

const LegalAgreement = ({ handleSubmitData, loading }: any) => {
  const [active, setActive] = useState(false);
  let loginInitialValues: FormInputs = {
    declaration: false,
    consent: "",
  };

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: loginInitialValues,
  });

  const agreements: Agreement[] = [
    { id: 0, text: "League logo must be specific site on Team jerseys." },
    { id: 1, text: "Referee’s decision is and will always be final." },
    { id: 2, text: "Respect league officials and their decision." },
    { id: 3, text: "Foul language against officials would not be tolerated" },
    { id: 4, text: "Compliance with league rules and regulations." },
    { id: 5, text: "Team players, owners, captains and coaches will conduct themselves in a respectful and cordial manner." },
    { id: 6, text: "Team will always prioritize safety both on and off the field" },
    { id: 7, text: "Refrain from drug abuse." },
    { id: 8, text: "No weapons allowed on the premises." },
    { id: 9, text: "Respect the security officials and protocols." },
  ];

  const RadiOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  const onSubmit = (value: any) => {
    setActive(value);
    setValue("consent", value);
  };

  return (
    <section className="first_form_container team_management">
      <div className="">
        <SHTText size="h2" text="Legal Agreements" color="gray" />
      </div>
      <div className="form_list">
        <div className="form_agreement">
          {agreements.map((agreement: Agreement) => (
            <ul className="form_list" key={agreement.id}>
              <li>
                <SHTText text={agreement.text} size="p" color="gray" />
              </li>
            </ul>
          ))}
          <div className="mb">
            <SHTText
              size="p"
              text={
                <p className="label_text">
                  <b>DECLARATION:</b> I certify that the information I have written on the application form and the documents I have submitted are true and accurate.
                </p>
              }
            />
            <Controller
              control={control}
              name="declaration"
              rules={{
                required: "You must indicate your consent by checking the box.",
              }}
              render={({ field: { value, onChange } }) => (
                <div>
                  <input
                    type="checkbox"
                    checked={value}
                    onChange={e => onChange(e.target.checked)}
                    style={{width: 20, height: 20, marginRight: 10, marginTop: 10}}
                  />{" "}
                  <span className="label_text">
                    Please check the box to indicate your consent.
                  </span>
                  {errors.declaration && (
                    <p className="text-danger">{errors.declaration.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        </div>
      </div>
      <div className="next_button player_form_button">
        <SHTButton
          type="submit"
          disabled={!getValues("declaration")}
          name="Submit"
          loading={loading}
          handleClick={handleSubmit(handleSubmitData)}
        />
      </div>
    </section>
  );
};

export default LegalAgreement;
